import { render, staticRenderFns } from "./afterSales.vue?vue&type=template&id=67d6448d&scoped=true"
import script from "./afterSales.vue?vue&type=script&lang=js"
export * from "./afterSales.vue?vue&type=script&lang=js"
import style0 from "./afterSales.vue?vue&type=style&index=0&id=67d6448d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d6448d",
  null
  
)

export default component.exports